/**
 * Shared schema.org JSON-LD builders for marketing pages. Pass the result to
 * useMarketingSeo({ jsonLd }), which injects each object as <script type="application/ld+json">
 * (and the prerender snapshots it into the static HTML crawlers/LLMs receive).
 *
 * Only emit structured data that matches what's actually visible on the page. We deliberately do
 * NOT emit FAQPage on the feature pages: they have no on-page Q&A, and Google requires the answer
 * to be visible — fabricated FAQ markup risks a manual action.
 */
const ORIGIN = "https://paceback.com";

interface Crumb {
  name: string;
  /** App-relative path beginning with "/". */
  path: string;
}

/** schema.org BreadcrumbList for a marketing page, e.g. Home → For coaches. */
export function breadcrumbList(trail: Crumb[]): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: trail.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: `${ORIGIN}${crumb.path}`,
    })),
  };
}
